/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/pages/auth/AuthPage`, `src/pages/home/HomePage`).
 */

import React from "react";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { useLastLocation } from "react-router-last-location";
import HomePage from "../pages/home/HomePage";
import ErrorsPage from "../pages/errors/ErrorsPage";
import LogoutPage from "../pages/auth/Logout";
import { LayoutContextProvider } from "../../_metronic";
import Layout from "../../_metronic/layout/Layout";
import * as routerHelpers from "../router/RouterHelpers";
import AuthPage from "../pages/auth/AuthPage";
import Privacy from "../pages/home/Privacy";
import ChangePassword from "../pages/home/ChangePassword";

export const Routes = withRouter(({ history }) => {
    const lastLocation = useLastLocation();

    routerHelpers.saveLastLocation(lastLocation);
    const { isAuthorized, menuConfig, userLastLocation, firstLogin } = useSelector(
        ({ auth, urls, builder: { menuConfig } }) => ({
            menuConfig,
            isAuthorized: auth.user != null,
            firstLogin: auth && auth.user && auth.user.firstLogin ? auth.user.firstLogin : 2,
            userLastLocation: routerHelpers.getLastLocation()
        }),
        shallowEqual
    );
    // const firstLogin = 1; // Login done
    // console.log('firstLogin', firstLogin);

    // let redirectUser = '';
    // if(firstLogin === 1 && isAuthorized) {
    //     redirectUser = (<Redirect from="/auth" to={"/privacy-policy"} />)
    // }
    // else if(isAuthorized) {
    //     redirectUser = (<Redirect from="/auth" to={"/"} />)
    // }
    // else {
    //     redirectUser = <AuthPage />
    // }
    // console.log('redirectUser', redirectUser);

    return (
        /* Create `LayoutContext` from current `history` and `menuConfig`. */
        <LayoutContextProvider history={history} menuConfig={menuConfig}>
            {/* {redirectUser} */}
            <Switch>
                {/* {!isAuthorized ? (
                    // Render auth page when user at `/auth` and not authorized.
                    <AuthPage />
                ) : (
                        // Otherwise redirect to root page (`/`)
                        <Redirect from="/auth" to={"/"} />
                    )} */}


                {(()=> {
                    if (!isAuthorized) {
                        return <AuthPage />
                    }
                    else if(isAuthorized && firstLogin !== 1) {
                        return <Redirect from="/auth" to={"/privacy-policy"} />
                    }
                    else {
                        return <Redirect from="/auth" to={"/"} />
                    }
                })()}

                <Route path="/privacy-policy" component={Privacy} firstLogin={true} />
                <Route path="/change-password" component={ChangePassword} firstLogin={true} />
                <Route path="/logout" component={LogoutPage} />
                <Route path="/error" component={ErrorsPage} />

                {(()=> {
                    if (!isAuthorized) {
                        return <Redirect to="/auth/login" />
                    }
                    else if(isAuthorized && firstLogin !== 1) {
                        return <Layout><HomePage userLastLocation={userLastLocation} /></Layout>
                    }
                    else {
                        return <Layout><HomePage userLastLocation={userLastLocation} /></Layout>
                    }
                })()}

                {/* {!isAuthorized ? (
                    // Redirect to `/auth` when user is not authorized
                    <Redirect to="/auth/login" />
                ) : (
                        <Layout>
                            <HomePage userLastLocation={userLastLocation} />
                        </Layout>
                    )} */}
            </Switch>
        </LayoutContextProvider>
    );
});
